import React, { FC } from 'react';
import useMediaQuery, { sharedMediaQueries } from 'src/common/hooks/useMediaQuery';
import { EXTERNAL_PATHS } from '../../constants';
import NavItemDropdown from './NavItemDropdown';

const MyListingsNavItem: FC = () => {
  const isMediumAndUpScreenSize = useMediaQuery(sharedMediaQueries.m);

  return (
    <NavItemDropdown
      icon="listings"
      options={[
        {
          dropdownLabel: 'Boats & Pricing',
          icon: isMediumAndUpScreenSize ? undefined : 'boat',
          id: EXTERNAL_PATHS.ADMIN_LISTINGS,
        },
        {
          dropdownLabel: 'Add-On Manager',
          icon: isMediumAndUpScreenSize ? undefined : 'hand-coins',
          id: EXTERNAL_PATHS.ADMIN_ADDONS,
        },
      ]}
    >
      My Listings
    </NavItemDropdown>
  );
};

export default MyListingsNavItem;
